import axios from "axios";
import { Templator } from "../../../utils";
class Templates extends Templator {
    constructor() {
        super(...arguments);
        this.fetchOptimizationUploadTemplate = async (params) => {
            const queryParams = `?mediaType=${params.mediaType}`;
            const url = params.templateId
                ? `${this.sdk.urls.baseAPIUrl}/template/publisher/${params.templateId}/export${queryParams}`
                : `${this.sdk.urls.baseAPIUrl}/template/publishers/export${queryParams}`;
            const { data } = await axios.get(url, {
                responseType: "blob"
            });
            return data;
        };
    }
    createTemplate(params) {
        return this.fetchOptimizationUploadTemplate(params);
    }
}
export default Templates;
//# sourceMappingURL=templates.js.map